import { Component } from '@angular/core';

@Component({
    selector: 'analytics', template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AnalyticsComponent {}
